import * as React from "react";
import "@ant-design/v5-patch-for-react-19";
import { createRoot } from "react-dom/client";
import { DetachedConnect } from "./pages/workload/detail/detachedConnect";
import "xterm/css/xterm.css";
import "./tailwind.output.css";
import "./index.css";
import { EntryPoint } from "./entryPoint";
import { Provider } from "react-redux";
import { store } from "./store";

function executeApp() {
  // Redirect new.* subdomains to main URL
  const hostname = window.location.hostname;
  if (hostname.startsWith("new.")) {
    window.location.hostname = hostname.slice(4);
    return;
  }

  console.log(`React ${React.version}`);
  console.log(`MODE ${import.meta.env.MODE}`);
  console.log(`MODE VARIATION ${import.meta.env.MODE_VARIATION}`);

  const domNode = document.getElementById("root");
  const root = createRoot(domNode!);

  // Detached Connect
  if (window.location.pathname.startsWith("/connect")) {
    root.render(<DetachedConnect />);
    return;
  }

  root.render(
    <>
      <Provider store={store}>
        <EntryPoint />
      </Provider>
      ,
    </>,
  );
}

executeApp();
